export default {
  oops: '¡Huy!',
  validOrigin: 'Por favor, seleccione una ubicación de salida válida',
  validDestination: 'Por favor, seleccione un destino válido',
  validOutboundDate: 'Por favor, seleccione una fecha de salida válida',
  validReturnDate: 'Por favor, seleccione una fecha de regreso válida',
  validChildAges: 'Por favor, indica la edad de todos los niños.',
  oneChild: 'Solo puede viajar 1 niño (de 0 a 2 años) por adulto',
}
